import {
  Component,
  Input,
  signal,
  Optional,
  Self,
  effect
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlValueAccessor, FormsModule, NgControl } from '@angular/forms';
import {
  DropdownComponent,
  DropdownItem
} from '../dropdown/dropdown.component';

@Component({
  selector: 'app-form-dropdown',
  standalone: true,
  imports: [CommonModule, FormsModule, DropdownComponent],
  template: `
    <div class="input">
      @if (label) {
        <label [for]="id" class="input-label-item">{{ label }}</label>
      }
      <div class="form-dropdown-wrapper">
        <app-dropdown
          [id]="id"
          [items]="items"
          [placeholder]="placeholder"
          [useAvatar]="false"
          [value]="currentValue()"
          (selectItem)="onItemSelected($event)"
        ></app-dropdown>
      </div>
      @if (showError()) {
        <div class="input-error mt-1">Este campo es requerido</div>
      }
    </div>
  `,
  styles: [
    `
      .form-dropdown-wrapper ::ng-deep .dropdown-trigger {
        border-radius: 12px !important;
        border: 1px solid #0033a0 !important;
        padding: 10px !important;
        height: auto !important;
        min-height: 48px !important;
      }
    `
  ]
})
export class FormDropdownComponent implements ControlValueAccessor {
  @Input() label = '';
  @Input() id = '';
  @Input() items: DropdownItem[] = [];
  @Input() placeholder = 'Seleccionar';

  readonly showError = signal(false);
  readonly currentValue = signal<any>(null);
  private onChange: (value: any) => void = () => {};
  private onTouched: () => void = () => {};
  private disabled = false;

  constructor(@Optional() @Self() public ngControl: NgControl) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }

    effect(() => {
      const control = this.ngControl?.control;
      if (control) {
        const hasError = control.invalid && (control.touched || control.dirty);
        this.showError.set(hasError);
      }
    });
  }

  onItemSelected(item: DropdownItem): void {
    if (!this.disabled) {
      this.currentValue.set(item.value);
      this.onChange(item.value);
      this.onTouched();
    }
  }

  writeValue(value: any): void {
    this.currentValue.set(value);
  }

  registerOnChange(fn: (value: any) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
